export const PORTABLE_KINDS = ["strategy", "run", "bundle"];
/**
 * Ceiling on one file's item count. A backtest result is the heavy part — a few
 * hundred of them is already a file measured in tens of megabytes, and beyond
 * that an "export everything" button stops being a useful gesture and starts
 * being a way to hang the browser.
 */
export const MAX_EXPORT_ITEMS = 500;
/**
 * What to do when an imported strategy's id already exists locally.
 *
 * `copy` is the default because it is the only one that cannot destroy work:
 * restoring your own backup and opening a colleague's file are the same
 * gesture, and only one of them wants the existing strategy overwritten.
 */
export const IMPORT_CONFLICT_MODES = ["copy", "replace", "skip"];
/** One-line summary of what a file holds, for an import preview. */
export function describeContents(contents) {
    const parts = [];
    const s = contents.strategies.length;
    const r = contents.runs.length;
    if (s > 0)
        parts.push(`${s} ${s === 1 ? "strategy" : "strategies"}`);
    if (r > 0)
        parts.push(`${r} ${r === 1 ? "run" : "runs"}`);
    return parts.length > 0 ? parts.join(" and ") : "nothing";
}
//# sourceMappingURL=document.js.map